import * as angular from "angular";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";

angular
  .module('bringoz.admin.expenses')
  .factory('$expensesCategories', expensesCategoriesObjectFactory);

function expensesCategoriesObjectFactory($bringozFactory: $bringozFactory,
                                         ExpensesCategoriesApi: BringozApi,
                                         ExpensesCategories_DS: DataStoreConfig) {

  function $expensesCategories(id: string) {
    return $bringozFactory(id, ExpensesCategoriesApi, ExpensesCategories_DS);
  }
  return $expensesCategories;
}

